// localhost
// export const domain = 'http://localhost:8000/';

//servertest
export const domain = 'https://ec-service.ksta.co/';

//production
// export const domain = 'https://service.irbrta-research.com/';